import Swiper from 'swiper/bundle';


import { index } from "./components/index";
function isSmartPhone() {
	if (window.matchMedia && window.matchMedia('(max-device-width: 768px)').matches) {
		return true;
	} else {
		return false;
	}
}

const smoothScrollTrigger = document.querySelectorAll('a[href^="#"]');
const header = document.querySelector('.l-header');
const hamburger = document.querySelector('.l-hamburger');
const nav = document.querySelector('.l-nav');

for (let i = 0; i < smoothScrollTrigger.length; i++) {
	smoothScrollTrigger[i].addEventListener('click', (e) => {
		e.preventDefault();
		hamburger.classList.remove('_active');
		nav.classList.remove('_active');
		let href = smoothScrollTrigger[i].getAttribute('href');
		let targetElement = document.getElementById(href.replace('#', ''));
		const rect = targetElement.getBoundingClientRect().top;
		const offset = window.pageYOffset;
		const gap = isSmartPhone() ? header.offsetHeight : 0;
		const target = rect + offset - gap;
		console.log(isSmartPhone());
		window.scrollTo({
			top: target,
			behavior: 'smooth',
		});
	});
}


hamburger.addEventListener('click', (e) => {
	e.preventDefault();
	hamburger.classList.toggle('_active');
	nav.classList.toggle('_active');
})

index();




const mainswiper = new Swiper(".p-company_photo .swiper", {
	loop: true,
	autoplay: {
		delay: 7000,
	},
	effect: 'fade',
	speed: 1000,
});



const staffswiper = new Swiper(".p-company_interview .swiper", {
	loop: true,
	autoplay: {
		delay: 7000,
	},
	effect: 'fade',
	speed: 1000,
});
